/* ============================================================
 * urgency-announcement.js — iShop El Salvador
 * Reescribe el primer mensaje del carrusel del announcement bar
 * con mensajes de urgencia según hora de El Salvador (America/El_Salvador).
 *
 * Estados (Lun–Vie, no festivo):
 *   1) 00:00 – state1_end (10:30)   → mensaje estático "HOY"
 *   2) state1_end – state2_end (13:30) → countdown "XXh XXm"
 *   3) state2_end – cutoff (14:30)  → countdown "XXm XXs"
 *   4) Resto (post-cutoff, sáb, dom, festivo) → "Recibe {dia}…"
 * ============================================================ */
(function () {
  'use strict';

  var CONFIG_ID = 'urgency-bar-config';
  var TIMEZONE = 'America/El_Salvador';
  var DAY_NAMES = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
  var DOW_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  var timer = null;
  var lastHTML = '';
  var targetEl = null;
  var cfg = null;

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      var raw = JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[urgency-bar] Config JSON inválido', e);
      return null;
    }
    return {
      enabled: raw.enabled !== false,
      selector: raw.selector || '.announcement__text .rte p',
      cutoffMin: parseTimeToMinutes(raw.cutoff, 14 * 60 + 30),
      state1EndMin: parseTimeToMinutes(raw.state1End, 10 * 60 + 30),
      state2EndMin: parseTimeToMinutes(raw.state2End, 13 * 60 + 30),
      workDays: parseWorkDays(raw.workDays, [1, 2, 3, 4, 5]),
      messages: {
        early: raw.messages && raw.messages.early || '',
        countdownHours: raw.messages && raw.messages.countdownHours || '',
        countdownMinutes: raw.messages && raw.messages.countdownMinutes || '',
        nextDay: raw.messages && raw.messages.nextDay || ''
      },
      holidays: parseHolidays(raw.holidays),
      offsetSeconds: parseInt(raw.offsetSeconds, 10) || 0
    };
  }

  function parseTimeToMinutes(str, fallback) {
    if (!str) return fallback;
    var m = String(str).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return fallback;
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (h > 23 || min > 59) return fallback;
    return h * 60 + min;
  }

  function parseWorkDays(raw, fallback) {
    if (!raw) return fallback;
    var arr = String(raw)
      .split(/[\s,;]+/)
      .map(function (s) { return parseInt(s, 10); })
      .filter(function (n) { return !isNaN(n) && n >= 0 && n <= 6; });
    return arr.length ? arr : fallback;
  }

  function parseHolidays(raw) {
    if (!raw) return [];
    return String(raw)
      .split(/[\s,;]+/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function svParts(msTimestamp) {
    var d = new Date(msTimestamp);
    var fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIMEZONE,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false, weekday: 'short'
    });
    var parts = {};
    fmt.formatToParts(d).forEach(function (p) { parts[p.type] = p.value; });
    var hour = parseInt(parts.hour, 10);
    if (hour === 24) hour = 0;
    return {
      date: parts.year + '-' + parts.month + '-' + parts.day,
      dow: DOW_MAP[parts.weekday],
      secondsOfDay: hour * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10)
    };
  }

  function isHoliday(dateStr) {
    return cfg.holidays.indexOf(dateStr) !== -1;
  }

  function isWorkDay(dow) {
    return cfg.workDays.indexOf(dow) !== -1;
  }

  function nextDeliveryLabel(nowMs, sv) {
    if (isWorkDay(sv.dow) && !isHoliday(sv.date) && sv.secondsOfDay < cfg.cutoffMin * 60) {
      return 'HOY';
    }
    var DAY_MS = 86400000;
    for (var n = 1; n <= 10; n++) {
      var cand = svParts(nowMs + n * DAY_MS);
      if (isWorkDay(cand.dow) && !isHoliday(cand.date)) {
        return n === 1 ? 'MAÑANA' : 'EL ' + DAY_NAMES[cand.dow];
      }
    }
    return 'PRONTO';
  }

  function buildHTML() {
    var nowMs = Date.now() + cfg.offsetSeconds * 1000;
    var sv = svParts(nowMs);
    var sec = sv.secondsOfDay;
    var cutoffSec = cfg.cutoffMin * 60;

    var deliveryToday = isWorkDay(sv.dow) && !isHoliday(sv.date) && sec < cutoffSec;

    if (deliveryToday) {
      if (sec <= cfg.state1EndMin * 60) {
        return cfg.messages.early;
      }
      var remaining = cutoffSec - sec;
      if (sec <= cfg.state2EndMin * 60) {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        return cfg.messages.countdownHours.replace(/\{countdown\}/g, '<strong>' + h + 'h ' + pad2(m) + 'm</strong>');
      }
      var mm = Math.floor(remaining / 60);
      var ss = remaining % 60;
      return cfg.messages.countdownMinutes.replace(/\{countdown\}/g, '<strong>' + mm + 'm ' + pad2(ss) + 's</strong>');
    }

    return cfg.messages.nextDay.replace(/\{dia\}/g, nextDeliveryLabel(nowMs, sv));
  }

  function tick() {
    if (!targetEl || !document.body.contains(targetEl)) {
      targetEl = document.querySelector(cfg.selector);
      if (!targetEl) return;
      lastHTML = '';
    }
    var html = buildHTML();
    if (html && html !== lastHTML) {
      targetEl.innerHTML = html;
      lastHTML = html;
    }
  }

  function init() {
    cfg = readConfig();
    if (!cfg || !cfg.enabled) return;
    targetEl = document.querySelector(cfg.selector);
    lastHTML = '';
    if (timer) clearInterval(timer);
    tick();
    timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 50);
  });
})();